const areasData = [
	{
		id: 'shop',
		title: {
			da: 'Butik',
			kl: 'Pisiniarfik',
		},
		stats: [
			['customers', 'buying-customers', 'sales-price', 'experience']
		],
		actions: [
			{
				id: 'marketing',
				title: {
					da: 'Markedsføring',
					kl: 'Nittarsaaneq',
				},
				options: [
					{
						id: 'marketing-a',
						title: {
							da: 'Gadeevent',
							kl: 'Aqqusinermi pisoqartitsineq',
						},
						description: {
							da: 'I holder %another%en event uden for butikken. En af jeres venner kommer og er DJ, og der er gratis drikkevarer til de 50 første.',
							kl: 'Pisiniarfiup silataani %another%pisoqartitsivusi. Kammalaatersi aggerpoq DJ-iullunilu, 50-inut siullernut akeqanngitsumik imigassaqarpoq.',
						},
						replacement: {
							da: 'endnu ',
							kl: 'suli ',
						},
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'marketing-expenses',
								expenseTitle: {
									da: 'Gadeevent',
									kl: 'Aqqusinermi pisoqartitsineq',
								},
								price: 20000,
							},
							{
								type: 'add-to-stat',
								statId: 'marketing-effect',
								statValue: 2
							},
						]
					},
					{
						id: 'marketing-b',
						title: {
							da: 'Giveaways på lokale gymnasier',
							kl: 'Illoqarfiup ilinniarnertuunngorniarfiani tunniussuineq',
						},
						description: {
							da: 'I tager ud til et %another%gymnasium og giver shirts ud til dem der tør gøre noget skørt, som I kan smide på sociale medier, iført en af jeres shirt.',
							kl: '%another%Ilinniarnertuunngorniarfimmukarpusi, arlaannik asuli iliuuseqarnissaminnut sapinngitsunut tujuuluaqqanik agguaavusi, tujuuluaraatissinnik atuineri inuit attaveqatigiittarfiinut ikkussinnaallusigit.',
						},
						replacement: {
							da: 'nyt ',
							kl: 'nutaaq ',
						},
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'marketing-expenses',
								expenseTitle: {
									da: 'Giveaways på lokale gymnasier',
									kl: 'Illoqarfiup ilinniarnertuunngorniarfiani tunniussuineq',
								},
								price: 15000,
							},
							{
								type: 'add-to-stat',
								statId: 'marketing-effect',
								statValue: 1.5
							},
						]
					},
					{
						id: 'marketing-c',
						title: {
							da: 'Bod til metal-festival',
							kl: 'Metal-festivalimut tuniniaavik',
						},
						description: {
							da: 'En lokal festival trækker alle de unge i området til. I køber en bod på festivallen og kan sælge shirts der.',
							kl: 'Illoqarfimmi festivalip inuusuttut tamarmik piffimmukaatippai. Festivalimi tuniniaavissivusi tassanilu tujuuluaqqanik tuniniaasinnaallusi.',
						},
						isLocked: true,
						isRepeatableAfterXRounds: 2,
						effects: [
							{
								type: 'expense',
								expenseType: 'marketing-expenses',
								expenseTitle: {
									da: 'Bod til metal-festival',
									kl: 'Metal-festivalimut tuniniaavik',
								},
								price: 35000,
							},
							{
								type: 'add-to-stat',
								statId: 'marketing-effect',
								statValue: 3
							},
						]
					},
					{
						id: 'marketing-d',
						title: {
							da: 'Online markedsføring',
							kl: 'Nittartakkatigut nittarsaaneq',
						},
						description: {
							da: `I igangsætter kampagner på sociale medier.`,
							kl: 'Inuit attaveqatigiittarfiisigut piseqqusaarutinik aallartitsivusi.',
						},
						isRepeatableAfterXRounds: 0,
						isLocked: true,
						effects: [
							{
								type: 'expense',
								expenseType: 'marketing-expenses',
								expenseTitle: {
									da: 'Online markedsføring',
									kl: 'Nittartakkatigut nittarsaaneq',
								},
								price: 50000,
							},
							{
								type: 'add-to-stat',
								statId: 'marketing-effect',
								statValue: 4
							},
						]
					},
					{
						id: 'marketing-e',
						title: {
							da: 'Influencer',
							kl: 'Sunniiniartartoq',
						},
						description: {
							da: `I indgår en aftale med influenceren Swanja Morgengry om, at hun skal bruge jeres shirts og lave en række opslag om jeres butik.`,
							kl: 'Sunniiniartartoq Swanja Morgengry tujuuluaraatissinnik atueqqullugu aamma pisiniarfissi pillugu arlariinnik ikkusseqqullugu isumaqatigiissuteqarfigaarsi.',
						},
						isRepeatableAfterXRounds: 2,
						isLocked: true,
						effects: [
							{
								type: 'expense',
								expenseType: 'marketing-expenses',
								expenseTitle: {
									da: 'Influencer',
									kl: 'Sunniiniartartoq',
								},
								price: 90000,
							},
							{
								type: 'add-to-stat',
								statId: 'marketing-effect',
								statValue: 5
							},
						]
					},
					{
						id: 'marketing-f',
						title: {
							da: 'Plakatkampagne',
							kl: 'Allagartarsuarnik piseqqusaaruteqarneq',
						},
						description: {
							da: `I får trykt en masse plakater, som I hænger op rundt omkring i byen!`,
							kl: 'Allagartarsuarpassuarnik anillatsitsivusi, illoqarfimmilu taakku nivinngaassorpasi!',
						},
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'marketing-expenses',
								expenseTitle: {
									da: 'Plakatkampagne',
									kl: 'Allagartarsuarnik piseqqusaaruteqarneq',
								},
								price: 5000,
							},
							{
								type: 'add-to-stat',
								statId: 'marketing-effect',
								statValue: 0.7
							},
						]
					}
				],
			},
			{
				id: 'offer-campaign',
				title: {
					da: 'Prissætning',
					kl: 'Akimik aalajangersaaneq',
				},
				options: [
					{
						id: 'offer-campaign-a',
						title: {
							da: 'Salgspris',
							kl: 'Tuninerani akia',
						},
						description: {
							da: 'Ændrer salgsprisen.',
							kl: 'Tuniniarnerani akianik allannguineq.',
						},
						type: 'select',
						stepSize: 50,
						minVal: 50,
						maxVal: 1000,
						unit: {
							da: 'kr',
							kl: 'kr',
						},
						isRepeatableAfterXRounds: 0,
						statId: 'sales-price-selected',
						modifiesStatId: 'sales-price-base',
						effects: [
							{
								type: 'change-stat-selected',
								statId: 'sales-price-selected',
								modifiesStatId: 'sales-price-base'
							}
						]
					},
					{
						id: 'offer-campaign-b',
						title: {
							da: 'Tilbudskampagne 20%',
							kl: 'Piseqqusaaruteqarnermi akikilliliineq 20%',
						},
						description: {
							da: 'En måned med 20% tilbud på alle shirts.',
							kl: 'Qaammat ataaseq tujuuluaqqat tamarmik 20%-imik akikillissapput.',
						},
						isRepeatableAfterXRounds: 3,
						effects: [
							{
								type: 'sale',
								value: 0.2
							},
							{
								type: 'add-to-stat',
								statId: 'buying-customers-boost',
								statValue: 5
							}
						]
					},
					{
						id: 'offer-campaign-c',
						title: {
							da: 'Tilbudskampagne 40%',
							kl: 'Piseqqusaaruteqarnermi akikilliliineq 40%',
						},
						description: {
							da: 'En måned med 40% tilbud på alle shirts.',
							kl: 'Qaammat ataaseq tujuuluaqqat tamarmik 40%-imik akikillissapput.',
						},
						isRepeatableAfterXRounds: 3,
						effects: [
							{
								type: 'sale',
								value: 0.4
							},
							{
								type: 'add-to-stat',
								statId: 'buying-customers-boost',
								statValue: 10
							}
						]
					},
				],
			},
			{
				id: 'shop',
				title: {
					da: 'Butik',
					kl: 'Pisiniarfik',
				},
				options: [
					{
						id: 'shop-a',
						title: {
							da: 'Butiksindretning',
							kl: 'Pisiniarfimmi inississuineq',
						},
						description: {
							da: 'I skifter indretningen til en cool New Yorker stil.',
							kl: 'New Yorkermiorpalaartumik torrattumik inississuivusi.',
						},
						isRepeatableAfterXRounds: 0,
						isLocked: true,
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Butiksindretning',
									kl: 'Pisiniarfimmi inississuineq',
								},
								price: 55500,
							},
							{
								type: 'add-to-stat',
								statId: 'experience',
								statValue: 3
							},
							{
								type: 'lock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-a'
							},
							{
								type: 'unlock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-d'
							}
						]
					},
					{
						id: 'shop-d',
						title: {
							da: 'Butiksindretning',
							kl: 'Pisiniarfimmi inississuineq',
						},
						description: {
							da: 'I skifter indretningen til en flippet low key stil.',
							kl: 'Qasukkarsimaarpalaartumik inississuivusi.',
						},
						isLocked: true,
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Butiksindretning',
									kl: 'Pisiniarfimmi inississuineq',
								},
								price: 13500,
							},
							{
								type: 'add-to-stat',
								statId: 'experience',
								statValue: 1
							},
							{
								type: 'lock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-d'
							},
							{
								type: 'unlock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-a'
							}
						]
					},
					{
						id: 'shop-b',
						title: {
							da: 'Butiksmedhjælper',
							kl: 'Pisiniartitsinermut ikiorti',
						},
						description: {
							da: 'I hyrer en af jeres søskende til at hjælpe med salget om lørdagen og når der er koncerter på spillestedet.',
							kl: 'Qatanngutissi ilaat arfininngornikkut aammalu nipilersortarfimmi tusarnaartitsisoqaraangat tuniniaanermut ikiuuttussatut sulilersipparsi.',
						},
						isLocked: true,
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'additional-salaries',
								expenseTitle: {
									da: 'Butiksmedarbejer',
									kl: 'Pisiniartitsisoq',
								},
								price: 3*8000,
								isPermanent: true
							},
							{
								type: 'add-to-stat',
								statId: 'experience',
								statValue: 2
							},
							{
								type: 'lock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-b'
							},
							{
								type: 'unlock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-c'
							}
						]
					},
					{
						id: 'shop-c',
						title: {
							da: 'Opsig jeres butiksmedhjælper',
							kl: 'Pisiniartitsinermut ikiortersi suliunnaarsissiuk',
						},
						description: {
							da: '',
							kl: '',
						},
						isLocked: true,
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'additional-salaries',
								expenseTitle: {
									da: 'Butiksmedarbejer',
									kl: 'Pisiniartitsisoq',
								},
								price: -3*8000,
								isPermanent: true
							},
							{
								type: 'add-to-stat',
								statId: 'experience',
								statValue: -2
							},
							{
								type: 'unlock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-b'
							},
							{
								type: 'lock-action-option',
								actionId: 'shop',
								actionOptionId: 'shop-c'
							}
						]
					},

				],
			},
		]
	},
	{
		id: 'production',
		title: {
			da: 'Værksted',
			kl: 'Sullivik',
		},
		stats: [
			['stock', 'purchase', 'purchase-price'],
			['prod-capacity', 'production-price'],
			['design-expenses', 'design-quality'],
		],
		actions: [
			{
				id: 'tshirt-supplier',
				title: {
					da: 'Indkøb',
					kl: 'Pisiniarneq',
				},
				options: require('./supplier-actions-options').default
			},
			{
				id: 'buy-hardware',
				title: {
					da: 'Hardware',
					kl: 'Atortussat',
				},
				options: [
					{
						id: 'buy-hardware-a',
						title: {
							da: 'Ekstra printer',
							kl: 'Naqitsivik alla',
						},
						description: {
							da: `Køb en ekstra printer og varmetryk-maskine.
							<br />Maskinerne koster %price% kr.`,
							kl: `Saniatigut allamik naqitsivimmik kissartumillu naqitsivimmik pisigitsi.
							<br />Atortut akii %price% kr.`
						},
						isRepeatableAfterXRounds: 0,
						maxTimesSelectable: 2,
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Indkøb af hardware',
									kl: 'Atortussanik pisiniarneq',
								},
								price: 10000,
							},
							{
								type: 'add-to-stat',
								statId: 'prod-capacity-base',
								statValue: 700
							},
							{
								type: 'unlock-action-type',
								actionId: 'hire-helper-production'
							}
						]
					},
					{
						id: 'buy-hardware-b',
						title: {
							da: 'Direkte print',
							kl: 'Toqqaannaq naqitsineq',
						},
						description: {
							da: 'T-shirt printer til direkte tryk på t-shirts. Giver bedre kvalitet, øget og billigere produktion.',
							kl: 'Tujuuluaqqanik toqqaannaq naqitsinissamut anillatsitsivik. Pitsaassuseqartitsinerusoq, amerlanerusunik akikinnerusunillu sanaartortitsisoq.',
						},
						isLocked: true,
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Indkøb af hardware',
									kl: 'Atortussanik pisiniarneq',
								},
								price: 150000,
							},
							{
								type: 'add-to-stat',
								statId: 'quality-score-modifier',
								statValue: 1
							},
							{
								type: 'add-to-stat',
								statId: 'prod-capacity-base',
								statValue: 1500
							},
							{
								type: 'add-to-stat',
								statId: 'purchase-price',
								statValue: -3
							},
							{
								type: 'unlock-action-type',
								actionId: 'hire-helper-production'
							}
						]
					},
				],
			},
			{
				id: 'new-designs',
				type: 'box',
				title: {
					da: 'Designs',
					kl: 'Ilutsit',
				},
				options: require('./design-actions-options').default
			},
			{
				id: 'hire-helper-production',
				title: {
					da: 'Hjælper',
					kl: 'Ikiorti',
				},
				isLocked: true,
				options: [
					{
						id: 'hire-helper-production-a',
						title: {
							da: 'Hyr hjælper til produktion',
							kl: 'Sanaartornermut ikiortimik sulilersitsigitsi',
						},
						description: {
							da: 'Hyr en ven til at hjælpe til. Så kan I endnu bedre udnytte jeres nye printer.',
							kl: 'Kammalaatissinnik ikiuussinnaasumik sulilersitsigitsi. Naqitsivittaarsilu atorluarsinnaanerulerlusiuk.',
						},
						isLocked: true,
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'additional-salaries',
								expenseTitle: {
									da: 'Hjælper til produktion',
									kl: 'Sanaartornermut ikiorti',
								},
								price: 3 * 8500,
								isPermanent: true
							},
							{
								type: 'multiply-stat',
								statId: 'prod-capacity-modifier',
								statValue: 1.5
							},
							{
								type: 'lock-action-option',
								actionId: 'hire-helper-production',
								actionOptionId: 'hire-helper-production-a'
							},
							{
								type: 'unlock-action-option',
								actionId: 'hire-helper-production',
								actionOptionId: 'hire-helper-production-b'
							}
						]
					},
					{
						id: 'hire-helper-production-b',
						title: {
							da: 'Opsig jeres hjælper',
							kl: 'Ikiortersi suliunnaarsissiuk',
						},
						description: {
							da: '',
							kl: '',
						},
						isLocked: true,
						isRepeatableAfterXRounds: 0,
						effects: [
							{
								type: 'expense',
								expenseType: 'additional-salaries',
								expenseTitle: {
									da: 'Hjælper til produktion',
									kl: 'Sanaartornermut ikiorti',
								},
								price: -3 * 8500,
								isPermanent: true
							},
							{
								type: 'multiply-stat',
								statId: 'prod-capacity-modifier',
								statValue: (1./1.5)
							},
							{
								type: 'unlock-action-option',
								actionId: 'hire-helper-production',
								actionOptionId: 'hire-helper-production-a'
							},
							{
								type: 'lock-action-option',
								actionId: 'hire-helper-production',
								actionOptionId: 'hire-helper-production-b'
							}
						]
					}
				],
			}
		]
	},
	{
		id: 'office',
		title: {
			da: 'Kontor',
			kl: 'Allaffik',
		},
		pagesBtnText: {
			da: 'Regnskab',
			kl: 'Naatsorsuutit',
		},
		pages: [
			{
				id: 'last-quarter',
				title: {
					da: 'Sidste kvartal',
					kl: 'Ukiup sisamararterutaa kingulleq',
				}
			},
			{
				id: 'history',
				title: {
					da: 'Historik',
					kl: 'Nalunaarsukkat',
				}
			},
			{
				id: 'report',
				title: {
					da: 'Rapport',
					kl: 'Nalunaarusiaq',
				}
			}
		],
		actions: [
			{
				id: 'financing',
				title: {
					da: 'Finansiering',
					kl: 'Aningaasaliineq',
				},
				options: [
					{
						id: 'financing-a',
						title: {
							da: 'Dårligt og dyrt lille lån',
							kl: 'Taarsigassarsineq annikitsoq pitsaananilu akisooq',
						},
						description: {
							da: `Kræver en omsætning på 250.000 for at kunne få lånet.
							<br />Lån 50.000 kr til 15%.`,
							kl: `Taarsigassarsinissamut kaaviaartitat 250.000-imiittariaqarput.
							<br />50.000 kr.-mik 15%-imut taarsigassarsineq.`
						},
						conditions: [
							{
								type: 'minimum-budget-stat',
								statId: 'turnover',
								minVal: 250000
							}
						],
						effects: [
							{
								type: 'loan',
								amount: 50000,
								value: 1.15 * 50000,
								interest: 0.15,
								monthlyPayment: 8000,
							}
						]
					},
					{
						id: 'financing-b',
						title: {
							da: 'Bedre lån',
							kl: 'Taarsigassarsineq pitsaanerusoq',
						},
						description: {
							da: `Kræver en omsætning på 450.000 kr for at kunne få lånet.
							<br />Lån 150.000 kr til 15%`,
							kl: `Taarsigassarsinissamut kaaviaartitat 450.000-imiittariaqarput.
							<br />150.000 kr.-mik 15%-imut taarsigassarsineq.`
						},
						conditions: [
							{
								type: 'minimum-budget-stat',
								statId: 'turnover',
								minVal: 450000
							}
						],
						effects: [
							{
								type: 'loan',
								amount: 150000,
								value: 1.15 * 150000,
								interest: 0.15,
								monthlyPayment: 7500,
							}
						]
					},
					{
						id: 'financing-c',
						title: {
							da: 'Stort lån',
							kl: 'Taarsigassarsineq annertooq',
						},
						description: {
							da: `Banken tror på jer, og I kan tage et stort lån. Kræver en omsætning på 1.200.000 kr for at kunne få lånet.
							<br />Lån 350.000 kr til 8%`,
							kl: `Aningaaseriviup upperivaasi, annertuumillu taarsigassissinnaallusi. Taarsigassarsinissamut kaaviaartitat 1.200.000-imiittariaqarput.
							<br />350.000 kr.-mik 8%-imut taarsigassarsineq.`,
						},
						conditions: [
							{
								type: 'minimum-budget-stat',
								statId: 'turnover',
								minVal: 600000
							}
						],
						effects: [
							{
								type: 'loan',
								amount: 350000,
								value: 1.08 * 150000,
								interest: 0.08,
								monthlyPayment: 8000,
							}
						]
					},
					{
						id: 'financing-d',
						title: {
							da: 'Partner - sælg en del af jeres selskab',
							kl: 'Suleqatigisaq - ingerlatseqatigiiffissi ilaa tuniniarsiuk',
						},
						description: {
							da: `Det betyder at I i stedet for at dele overskudet med 3 som I gør nu, skal dele det med 4. I har fået et tilbud fra en der tilbyder at køb en anpart for %buyInPrice% kr som I så vil få tilført som likvide midler`,
							kl: `Taava imaappoq, massakkutuut sinneqartoorutit pingasunut avinnagit, sisamanngorlugit avissavasi.  Piginneqataanissamut %buyInPrice% kr -mik akiliilluni neqerooruteqartoqarpoq, taakkulu akiliisinnaassuseqarnissinnut ilanngunneqassallutik`,
						},
						effects: [
							{
								type: 'new-partner',
							}
						]
					},
				],
			},
			{
				id: 'innovation',
				title: {
					da: 'Innovation',
					kl: 'Nutaaliorneq',
				},
				options: [
					{
						id: 'innovation-a',
						title: {
							da: 'Lokale bands',
							kl: 'Najukkami nipilersortartoqatigiit',
						},
						description: {
							da: `I mødes med folk fra spillestedet og snakker
							<br />om muligheder for samarbejde. Måske er der også bands hvor I må trykke deres logoer?`,
							kl: `Nipilersortarfimmiit inunnik naapitsinissinni
							<br />suleqatigiinnissamut periarfissat pillugit oqaloqateqarpusi. Immaqa aamma nipilersortartoqatigiit arlaata ilisarnaataat naqissinnaavasi?`
						},
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Lokale bands',
									kl: 'Najukkami nipilersortartoqatigiit',
								},
								price: 3000
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'indie_01',
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'indie_02',
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'indie_03',
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'indie_04',
							}
						]
					},
					{
						id: 'innovation-b',
						title: {
							da: 'Research tur til Japan',
							kl: 'Japanimut paasissutissanik katersiartorneq',
						},
						description: {
							da: 'I har fået en god forbindelse i kunstmiljøet i Japan, som har inviteret jer på research tur.',
							kl: 'Japanimi eqqumiitsuliortut akornanni attaveqaatigilluarsinnaasarsivusi, paasissutissanillu katersiartornissassinnut qaaqqullusi.',
						},
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Research tur til Japan',
									kl: 'Japanimut paasissutissanik katersiartorneq',
								},
								price: 65000
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'kawaii_01'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'kawaii_02'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'kawaii_03'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'kawaii_04'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'kawaii_05'
							}
						]
					},
					{
						id: 'innovation-c',
						title: {
							da: 'Artforums',
							kl: 'Eqqumiitsuliornermi katerisimaarfiit',
						},
						description: {
							da: `Engager jer på artforums på nettet for at finde ud af hvad der er det fedeste lige nu, og se om I kan få aftaler med nogle upcoming kunststjerner.`,
							kl: `Eqqumiitsuliornermi katerisimaarfiit nittartakkatigut malinnaaffigilluarsigit, massakkorpiaq suut torraanerpaanersut paasiniarlugu, eqqumiitsuliortunik tusaamaneqaleriartuinnartussanik isumaqatigiissuteqalersinnaanerlusi takusiuk.`,
						},
						effects: [
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'psychedelic_01'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'psychedelic_02'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'psychedelic_03'
							}
						]
					},
					{
						id: 'innovation-d',
						title: {
							da: 'Metalfestival',
							kl: 'Metalfestivali',
						},
						description: {
							da: `Det lokale spillested har en årlig metalfestival. I mødes med arrangørerne af den for at høre om der kunne være nogle muligheder for samarbejde.`,
							kl: `Najukkami nipilersorfigineqartoq ukiumut ataasiarluni metalfestivalertitsisarpoq. Tassunga aaqqissuisut naapippasi, suleqatigiinnissamut periarfissaqarnerlusi tusarniarlugu.`,
						},
						isLocked: true,
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Metalfestival',
									kl: 'Metalfestivali',
								},
								price: 10000
							},
							{
								type: 'unlock-action-option',
								actionId: 'marketing',
								actionOptionId: 'marketing-c'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'metalband_01'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'metalband_02'
							},
							{
								type: 'unlock-action-option',
								actionId: 'new-designs',
								actionOptionId: 'metalband_03'
							}
						]
					},
					{
						id: 'innovation-e',
						title: {
							da: 'Online markedsføring',
							kl: 'Nittartakkatigut nittarsaaneq',
						},
						description: {
							da: `Væksthuset udbyder et kursus i online markedsføring.`,
							kl: `Illu ineriartortitsivik nittartakkatigut nittarsaanermut pikkorissarnissamik neqerooruteqarpoq.`,
						},
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Online markedsføring',
									kl: 'Nittartakkatigut nittarsaaneq',
								},
								price: 2600
							},
							{
								type: 'unlock-action-option',
								actionId: 'marketing',
								actionOptionId: 'marketing-d'
							},
							{
								type: 'unlock-action-option',
								actionId: 'marketing',
								actionOptionId: 'marketing-e'
							},
						]
					},
					{
						id: 'innovation-f',
						title: {
							da: 'Nye produktionsteknikker',
							kl: 'Sanaartoriaatsit nutaat',
						},
						description: {
							da: `Undersøg nye teknikker til produktion.`,
							kl: `Sanaartoriaatsinik nutaanik misissuigitsi.`,
						},
						effects: [
							{
								type: 'expense',
								expenseType: 'variable-expenses',
								expenseTitle: {
									da: 'Nye produktionsteknikker',
									kl: 'Sanaartoriaatsit nutaat',
								},
								price: 7000
							},
							{
								type: 'unlock-action-option',
								actionId: 'buy-hardware',
								actionOptionId: 'buy-hardware-b'
							},
						]
					}

				],
			}
		]
	}
];

module.exports = {
	areasData
};